import { useEffect, useLayoutEffect, useState } from "react";
import type { FC } from "react";
import { modulo } from "ramda";
import { StartupImageView } from "./startup-image.view";

interface StartupImageContainerProps {}

export const StartupImageContainer: FC<StartupImageContainerProps> = () => {
  const [imageIndex, setImageIndex] = useState<number | null>(null);

  useEffect(() => {
    const date = new Date();
    const dayOfMonth = date.getDate();
    setImageIndex(modulo(dayOfMonth, 4));
  }, []);

  return <StartupImageView {...{ imageIndex }} />;
};
